import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../mock/data";
import { Button } from "./ui/button";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center group">
          <img
            src="/brand/huntheal-logo.png"
            alt={`${COMPANY.brand} logo`}
            className="h-10 w-auto rounded-md group-hover:scale-105 transition-transform"
            width="470"
            height="128"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => {
            const active = location.pathname === l.href;
            return (
              <Link
                key={l.href}
                to={l.href}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  active
                    ? "text-emerald-700 bg-emerald-50"
                    : "text-slate-700 hover:text-emerald-700 hover:bg-emerald-50/60"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            className="hidden lg:inline-flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-emerald-700"
          >
            <Phone className="h-4 w-4" /> {COMPANY.phone}
          </a>
          <Button asChild className="bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm">
            <a href={`tel:${COMPANY.phoneRaw}`}>
              <Phone className="h-4 w-4 mr-2" /> Call Now
            </a>
          </Button>
        </div>

        <button
          className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md text-slate-700 hover:bg-slate-100"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm font-medium text-slate-700 hover:text-emerald-700 hover:bg-emerald-50"
              >
                {l.label}
              </Link>
            ))}
            <a
              href={`tel:${COMPANY.phoneRaw}`}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-emerald-600 text-white rounded-md py-2.5 font-medium"
            >
              <Phone className="h-4 w-4" /> Call {COMPANY.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
